/** Modifiers **/
export const loadOrders = (filter) => {
    return axios.get('/api/orders', {params: filter}).then(res => res.data);
}

export const loadOrderDetails = (orderId) => {
    return axios.get(`/api/order/${orderId}`).then(res => res.data);
}

export const actionOrder = (orderId, action, params) => {
    return axios.post(`/api/order/${orderId}`, { action : {
        ...action, ...params
    }}).then(res => res.data);
}
